<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Projetos</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="ADICIONAR PROJETO"
            (click)="openCadastro()">
            <mat-icon>add_circle</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"
            [footerHeight]="50" 
            [rowHeight]="'auto'"
            [rows]='rows'
        >

            <ngx-datatable-column
                name="Usuario" 
                matTooltip='Usuario' 
                prop="usuario">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.usuario?.name || 'Usuário não registrado' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Projeto" 
                matTooltip='tipo' 
                prop="tipo_projeto_id">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.tipo_projeto.nome_projeto}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Descrição" 
                matTooltip='Descrição' 
                prop="descricao">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.descricao}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Quando" 
                matTooltip='Quando' 
                prop="quando">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.quando ? (row.quando | date:'yyyy/MM') : '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Valor Estimado" 
                matTooltip='Valor' 
                prop="valor">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.valor | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Data Atualização" 
                matTooltip='Data da Última Atualização' 
                prop="updated_at">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.updated_at ? (row.updated_at | date:'yyyy/MM/dd') : '-' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button matTooltip="Editar" (click)="openAlterar(row.id)">
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" matTooltip="Excluir Item." (click)="delete(row.id)">
                        <mat-icon aria-label="Excluir Item">delete</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>